import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Main from '../components/Main';
import Users from '../components/Users';
import Visits from '../components/Visits';
import SolutionMapping from '../components/SolutionMapping';
import UnresolvedEntities from '../components/UnresolvedEntities';
import YtdReport from '../components/YtdReport';
import MomReport from '../components/MomReport';
import BackfillEntity from '../components/BackfillEntity';
import MainLayout from "../components/MainLayout";

function Router() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/ytd_report" replace />} />
        <Route path="/loginCallback" element={
          <MainLayout>
            <YtdReport />
          </MainLayout>
        } />
        <Route path="/dashboard" element={
          <MainLayout>
            <Main />
          </MainLayout>
        } />
        <Route path="/Users" element={
          <MainLayout>
            <Users />
          </MainLayout>
        } />
        <Route path="/visits" element={
          <MainLayout>
            <Visits />
          </MainLayout>
        } />
        <Route path="/solution_mapping" element={
          <MainLayout>
            <SolutionMapping />
          </MainLayout>
        } />
        <Route path="/unresolved_entities" element={
          <MainLayout>
            <UnresolvedEntities />
          </MainLayout>
        } />
        <Route path="/ytd_report" element={
          <MainLayout>
            <YtdReport />
          </MainLayout>
        } />
        <Route path="/mom_report" element={
          <MainLayout>
            <MomReport />
          </MainLayout>
        } />
        <Route path="/backfill_entity" element={
          <MainLayout>
            <BackfillEntity />
          </MainLayout>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
